import { Colors, ZIndex } from "@flatfile/design-system";
import { FlexCenter } from "../../../common/UI/Flex.js";
import { Shadows } from "../../../common/UI/Shadows.js";
import { TooltipContainerStyles } from "../Styles.js";
import styled, { keyframes } from "styled-components";
const grow = keyframes`
   from {
     width: 200px;
   }
   to {
     width: 100%;
   }
`;
const RemoveItem = styled.div`
  ${FlexCenter}
  cursor: pointer;
  padding-left: 4px;
  svg {
    transform: scale(0.5);
  }
`;
const Container = styled.div`
  ${TooltipContainerStyles}
  animation: ${grow} 10ms cubic-bezier(0.17, 0.67, 0.83, 0.67) forwards;
  transition: border 300ms ease-in;
  background: ${(props) => props.theme.backgroundColor};
  font-size: 12px;
`;
const Item = styled.div`
  ${FlexCenter}
  justify-content: center;
  text-align: center;
  width: 100%;
  margin: 0;
  padding: 0 10px;
  opacity: 0.96;
  user-select: none;
  cursor: grab;
  background: ${(props) => {
  if (props.error)
    return props.theme.cell.error.backgroundColor;
  if (props.warning)
    return props.theme.cell.warning.backgroundColor;
  return props.theme.backgroundColor;
}};
  color: ${(props) => {
  if (props.error)
    return props.theme.cell.error.color;
  if (props.warning)
    return props.theme.cell.warning.color;
  return props.theme.cell.color;
}};
  border-radius: ${(props) => {
  const tooltipBorderRadius = props.theme.tooltip.borderRadius;
  if (props.first && props.last) {
    return `${tooltipBorderRadius} ${tooltipBorderRadius} ${tooltipBorderRadius} ${tooltipBorderRadius}`;
  }
  if (props.first) {
    return `${tooltipBorderRadius} ${tooltipBorderRadius} 0 0`;
  }
  if (props.last) {
    return `0 0 ${tooltipBorderRadius} ${tooltipBorderRadius}`;
  }
  return `none`;
}};

  svg {
    stroke: ${(props) => {
  if (props.error)
    return props.theme.multiValue.error.svg.color;
  if (props.warning)
    return props.theme.multiValue.warning.svg.color;
  return props.theme.multiValue.svg.color;
}};
  }
`;
const ListWrapper = styled.div``;
const ListInput = styled.input`
  color: inherit;
  font-size: 12px;
  font-family: inherit;
  border: none;
  width: 100%;
  height: 31px;
  background: ${Colors.Transparent};

  &:focus {
    outline: none;
  }
`;
const Icon = styled.div`
  padding-right: 8px;
`;
styled.span`
  display: inline-block;
  background-color: ${(props) => {
  if (props.error)
    return props.theme.cell.error.backgroundColor;
  if (props.warning)
    return props.theme.cell.warning.backgroundColor;
}};
  color: ${(props) => {
  if (props.error)
    return props.theme.cell.error.color;
  if (props.warning)
    return props.theme.cell.warning.color;
  return props.theme.cell.color;
}};
  //height: 20px;
  text-decoration: inherit;
`;
const LabelContainer = styled.span`
  display: flex;
  flex-direction: row;
  gap: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Draggable = styled.div`
  transform: ${(props) => props.transform};
  transition: ${(props) => props.transition};
  cursor: grabbing;
  box-shadow: ${Shadows.default};
  position: ${(props) => props.isDragging ? "relative" : "static"};
  z-index: ${(props) => props.isDragging ? ZIndex.level200 : ZIndex.level100};
`;
export {
  Container,
  Draggable,
  Icon,
  Item,
  LabelContainer,
  ListInput,
  ListWrapper,
  RemoveItem
};
